import { icons, sizesIcon, } from "@affinitysystemsgroup/github-packages-affinity-components/dist";
export var view = [
    {
        active: false,
        icon: {
            icon: icons.List,
        },
        id: "1",
        name: "List",
    },
    {
        active: true,
        icon: {
            icon: icons.GridView,
        },
        id: "2",
        name: "GridView",
    },
];
export var buttonActionOptions = [
    {
        icons: icons.Menu,
        id: "1",
        name: "Modificar",
    },
    {
        icons: icons.Menu,
        id: "2",
        name: "Eliminar",
    }
];
export var buttonActionOptionsList = [
    {
        disabled: false,
        id: "1",
        name: "Modificar",
        divider: false,
        icon: {
            color: "#006ac6",
            icon: icons.Edit,
            size: sizesIcon.standard,
        },
    },
    {
        disabled: false,
        id: "2",
        name: "Eliminar",
        divider: false,
        icon: {
            color: "#006ac6",
            icon: icons.DeleteForever,
            size: sizesIcon.standard,
        },
    },
];
export var optionsSelect = [
    {
        id: "1",
        name: "Banesco",
        value: "1",
    },
];
